import Vue from "vue";
import VueRouter from "vue-router";

import Home from "../views/Home.vue";
import Rutas from "../views/Rutas";
import RutaDetalle from "../views/RutaDetalle";
import Parada from "../views/Parada";
import Logout from "../views/Logout";
import ParadaTardeCole from "@/views/ParadaTardeCole";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Login",
    component: Home
  },
  {
    path: "/logout",
    name: "Logout",
    component: Logout
  },
  {
    path: "/rutas/",
    name: "Rutas",
    component: Rutas
  },
  {
    path: "/ruta-detalle/:id",
    name: "Ruta",
    component: RutaDetalle,
    props: true
  },
  {
    path: "/parada/:orden",
    name: "Parada",
    component: Parada,
    props: true
  },
  {
    path: "/parada-cole-tarde/:orden",
    name: "Cole Tarde",
    component: ParadaTardeCole,
    props: true
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  }
];

const router = new VueRouter({
  routes,
  history: false,
  linkActiveClass: "active"
});

export default router;
